import { useState } from "react";

export const getFieldNameBuilder = (fieldPrefix) => {
  return (field) => {
    return fieldPrefix
      ? `${fieldPrefix}[${field}]`
      :  field;
  }
};

// Extracts "lastthing" from formthing[subobject][lastthing]
export const extractLastFieldName = (squareBracketField) => {
  const regexPattern = /\[([^\[\]]+)\](?![^\[\]]*\[\w+\])/;
  const match = squareBracketField.match(regexPattern);
  return match ? match[1] : '';
};



export const weekDaysIndexed = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  7: 'Sunday',
  '-1': 'Day',
};

export const monthsIndexed = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December'
}

export const dayDescriptors = {
  'first': 'First',
  'second': 'Second',
  'third': 'Third',
  'fourth': 'Fourth',
  'last': 'Last',
  'dayofmonth': 'Day of month'
}

export const frequencyTypes = { 'yearly': 'Year', 'monthly': 'Month', 'weekly': 'Week' };

export const initDatePatternState = (datePatternArgs = {}) => {
  let dayDescriptor, dayOfMonth;
  if ( !isNaN( Number(datePatternArgs.day_descriptor ) ) ) { // Day descriptor is numeric
    dayOfMonth = datePatternArgs.day_descriptor ?? 1
    dayDescriptor = 'dayofmonth'
  } else {
    dayOfMonth = datePatternArgs.day_number ?? 1
    dayDescriptor = datePatternArgs.day_descriptor ?? 'first'
  }

  return useState({
    month: datePatternArgs.month ?? 1,
    dayDescriptor: dayDescriptor,
    dayOfWeek: datePatternArgs.day_number ?? 1,
    dayOfMonth: dayOfMonth
  })
}


// Will flatten hierarchies by assigning underscores to keys, concatenating them at top-level.
// By default, it will flatten any object.
// If "include" is not empty, will only flatten specified keys.
export function flattenObjectRecursive(obj, prefix = '', exclude = [], include = []) {
  let result = {};

  for (let key in obj) {
    if(exclude.includes(key)) {
      result[key] = obj[key]
      continue
    } else if (include.length > 0 && !include.includes(key)) {
      result[key] = obj[key]
      continue
    }

    // Include the original key and value in the result
    if (prefix !== '') {
      result[`${prefix}${key}`] = obj[key];
    } else {
      result[key] = obj[key];
    }

    // Continue to flatten if the value is an object and not an array
    if (typeof obj[key] === 'object' && !Array.isArray(obj[key]) && obj[key] !== null) {
      const flattened = flattenObjectRecursive(obj[key], `${prefix}${key}_`);
      result = { ...result, ...flattened };
    }
  }

  return result;
}

export function labelValueArrayToObject(arr) {
  return arr.reduce((obj, item) => {
    obj[item.value] = item.label;
    return obj;
  }, {});
}
